import { newE2EPage } from '@stencil/core/testing';

describe('jackery-commetn-header', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-commetn-header></jackery-commetn-header>');

    const element = await page.find('jackery-commetn-header');
    expect(element).toHaveClass('hydrated');
  });
});
